var React = require('react');

function BullePopin (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"SVGID_1_","d":"M450.333,345.668c0,6.627-5.373,12-12,12h-406c-6.627,0-12-5.373-12-12v-318c0-6.627,5.373-12,12-12h406\r\n\t\t\tc6.627,0,12,5.373,12,12V345.668z"})),React.createElement("clipPath",{"id":"SVGID_2_","key":1},React.createElement("use",{"xlinkHref":"#SVGID_1_","overflow":"visible"})),React.createElement("g",{"clipPath":"url(#SVGID_2_)","key":2},React.createElement("path",{"d":"M18.921,270.829c3.681-74.606-124.025-79.239-127.705-126.809c-2.03-26.346-23.863-134.868,0-160.691\r\n\t\t\tc72.505-78.466,436.945-71.734,462.659,17.213c22.032,91.822,21.36,149.482-25.714,167.939\r\n\t\t\tC265.901,192.9,26.27,193.354,18.921,270.829z"}))]));
}

BullePopin.defaultProps = {"version":"1.1","id":"Calque_1","x":"0px","y":"0px","width":"100%","height":"100%","viewBox":"0 0 388.667 272.001","xmlSpace":"preserve"};

module.exports = BullePopin;

BullePopin.default = BullePopin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/assets/bulle-popin.svg
// module id = 375
// module chunks = 0